import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import kebabCase from 'lodash.kebabcase';
import useSiteMetadata from '../../utils/useSiteMetadata';
import * as styles from './tagsSection.module.css';

type Props = {
  currentTagName?: string;
};

export default ({ currentTagName }: Props) => (
  <StaticQuery
    query={graphql`
      query {
        allPost {
          group(field: tags___name) {
            fieldValue
            totalCount
          }
        }
      }
    `}
    render={(data) => {
      const { tagsPath, itemListPath } = useSiteMetadata();
      const firstTagsNames = ['Professional', 'Personal', 'Favourites'];
      const firstTags = firstTagsNames.map((tagName) =>
        data.allPost.group.find((item) => item.fieldValue === tagName)
      );
      const otherTags = data.allPost.group.filter(
        (item) => !firstTagsNames.includes(item.fieldValue)
      );
      const renderTag = (item, i) =>
        currentTagName === item.fieldValue ? (
          <span key={i} className={`${styles.tagContent} ${styles.current}`}>
            {item.fieldValue} ({item.totalCount})
          </span>
        ) : (
          <Link
            className={styles.tagContent}
            key={i}
            to={`/${tagsPath}/${kebabCase(item.fieldValue)}`.replace(
              /\/\/+/g,
              `/`
            )}
          >
            {item.fieldValue} ({item.totalCount})
          </Link>
        );

      return (
        <div className={styles.tagsSection}>
          {currentTagName === 'All' ? (
            <span className={`${styles.tagContent} ${styles.current}`}>
              All
            </span>
          ) : (
            <Link className={styles.tagContent} to={itemListPath}>
              All
            </Link>
          )}
          {firstTags.map(renderTag)}
          {otherTags.map(renderTag)}
        </div>
      );
    }}
  />
);
